module.exports = __webpack_public_path__ + "img/badge.9bdf6ae3.png";